<template>
  <div class="conversion-wrapper">
    <div class="conversion-list">
      <sp-tabs v-model="active_index" :tabs="tabs_config">
        <template #default="{ tabs, activeIndex }">
          <div class="view-wrapper">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-scrollbar wrap-style="overflow-x: hidden;" style="height: 450px">
                  <el-card shadow="never">
                    <span slot="header" class="font-16">已有转化</span>
                    <keep-alive>
                      <conversion-event :key="activeIndex" v-bind="tabs[activeIndex].componentProps" @confirm="onSelectConversion" />
                    </keep-alive>
                  </el-card>
                </el-scrollbar>
              </el-col>
              <el-col :span="12">
                <el-scrollbar wrap-style="overflow-x: hidden;" style="height: 450px">
                  <quick-selected :key="activeIndex" ref="selected_ref" v-bind="tabs[activeIndex].componentProps" />
                </el-scrollbar>
              </el-col>
            </el-row>
          </div>
        </template>
      </sp-tabs>

    </div>
    <div class="flex items-center justify-center" style="border-top: 1px solid #eee;">
      <div class="mt-20">
        <el-button size="medium" type="primary" icon="el-icon-position" @click="onConfirm">确定</el-button>
        <el-button size="medium" type="info" icon="el-icon-close" @click="$emit('cancel')">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { clone } from '@/utils';
import { isEmpty } from '@/utils/is';

export default {
  components: {
    'conversion-event': () => import('./conversion-event/index.vue'),
    'quick-selected': () => import('./selected/index.vue'),
    'sp-tabs': () => import('@/components/sp-tabs'),
  },
  mixins: [data_sharing_mixin],
  props: {
    /** 当前配置的渠道字段 */
    channelCodesField: {
      type: Object,
      required: true,
    },
    /** 表格基础查询参数 */
    tableParams: {
      type: Object,
      required: true,
    },
    /** 转化表格请求方法 */
    getList: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      tabs_config: [],
      active_index: 0,
      raw_data: {},
    };
  },
  created() {
    this.generateTabsConfig(this.channelCodesField);
  },
  methods: {
    /**
     * 生成tab配置
     * @param {Object} cur_data 渠道数据
     * @returns {void}
     */
    generateTabsConfig(cur_data) {
      Object.assign(this.raw_data, clone(cur_data));
      const base_params = clone(this.tableParams);
      const handler = (advertiser) => {
        const raw_codes = advertiser.list;
        const table_sources = raw_codes.map(row => {
          return Object.assign(row, {
            conversion: row.conversion || '',
          });
        });
        const table_params = {
          ...base_params,
          advertiser_id: advertiser.advertiser_id,
        };
        return {
          label: advertiser.label,
          componentProps: {
            advertiserId: advertiser.advertiser_id,
            tableParams: table_params,
            getList: this.getList,
            tableSources: {
              list: table_sources,
              page_info: {
                total_number: table_sources.length,
                page: 1,
                page_size: 10,
                total_page: 0,
              },
            },
          },
        };
      };
      this.tabs_config = this.raw_data.value.map(handler);
    },
    /**
     * 应用转化
     * @param {Object} data 当前行数据
     * @returns {void}
     */
    onSelectConversion(data) {
      const list = this.tabs_config[this.active_index].componentProps.tableSources.list;
      const { refreshTable, multiple_selection } = this.$refs['selected_ref'];
      if (multiple_selection.length) {
        for (let i = 0; i < multiple_selection.length; i++) {
          const row = multiple_selection[i];
          const new_data = clone(data);
          this.$set(row, 'conversion', JSON.stringify(new_data));
          multiple_selection.splice(i, 1);
          break;
        }
      } else {
        for (let i = 0; i < list.length; i++) {
          const row = list[i];
          if (isEmpty(row.conversion)) {
            const new_data = clone(data);
            this.$set(row, 'conversion', JSON.stringify(new_data));
            break;
          }
        }
      }
      refreshTable();
    },

    /**
     * 确定应用转化
     * @returns {void}
     */
    onConfirm() {
      this.$emit('confirm', {
        channels_codes: clone(this.raw_data),
        template_data: this.tabs_config[0].componentProps.tableSources.list[0]?.conversion,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.view-wrapper {
  padding: 0 20px 20px;
}
.conversion-list {
  height: 500px;
}
</style>
